const config = {
  local: ()=>({
      BASE_API_URL: 'http://localhost:8080/api-proxy',
      SSO_URL: 'http://localhost:3000/login',
      SSO_LOGOUT: 'http://localhost:8080/logout',
      ENV: 'local'
  }),
  dev: () => ({
    BASE_API_URL: 'https://ddir-bff.rhq-stage.samsclub.com/api-proxy',
    SSO_URL: 'https://ddir-bff.rhq-stage.samsclub.com/getSSOLoginURL',
    SSO_LOGOUT: ''
  }),
  stg: ()=>({
    BASE_API_URL: 'https://ddir-bff.rhq-stage.samsclub.com/api-proxy',
    SSO_URL: 'https://pfedcert.wal-mart.com/idp/startSSO.ping?PartnerSpId=ddir&ACSIdx=2',
    SSO_LOGOUT: ''
  }),
  prod: ()=>({
    BASE_API_URL: 'https://ddir-bff.rhq.samsclub.com/api-proxy',
    SSO_URL: 'https://pfedprod.wal-mart.com/idp/startSSO.ping?PartnerSpId=ddir&ACSIdx=2',
    SSO_LOGOUT: ''
  }),
  none: /* istanbul ignore next */ () => ({
    BASE_API_URL: 'https://ddir-bff.ddir.stage.k8s.walmart.net/api-proxy',
    SSO_URL: 'https://pfedcert.wal-mart.com/idp/startSSO.ping?PartnerSpId=ddir&ACSIdx=2',
    SSO_LOGOUT: ''
  })
};

export const getCurrentEnvironment = () => {
  console.log("window.location*****", window.location, window.location.host);
  let currentEnvironment;
  /* istanbul ignore else */
  if (typeof window !== 'undefined') {
    if (window.location.host.indexOf('local') !== -1) {
      currentEnvironment = 'local';
    } else if (window.location.host.indexOf('dev') !== -1) {
      currentEnvironment = 'dev';
    } else if (window.location.host.indexOf('qa') !== -1) {
      currentEnvironment = 'qa';
    } else if (window.location.host.indexOf('stg') !== -1 || window.location.host.indexOf('stage') !== -1) {
      currentEnvironment = 'stg';
    } else {
      currentEnvironment = 'prod';
    }
    return currentEnvironment;
  }
  /* istanbul ignore next */
  return 'none';
};

export function getConfiguration() {
  const environments = ['local', 'dev', 'wcnp-dev', 'qa', 'stg', 'stage', 'prod', 'none'];
  const currentEnvironment = getCurrentEnvironment();
  /* istanbul ignore else */
  if (environments.includes(currentEnvironment)) {
    return config[currentEnvironment]();
  }
  /* istanbul ignore next */
  return config.dev();
}

export const SSO_URL = config[getCurrentEnvironment()]().SSO_URL;
export const BASE_API_URL = config[getCurrentEnvironment()]().BASE_API_URL;
export const ENV = config[getCurrentEnvironment()]().ENV || /* istanbul ignore next */ getCurrentEnvironment();
export const SSO_LOGOUT = config[getCurrentEnvironment()]().SSO_LOGOUT || /* istanbul ignore next */ '';

// Non-Variant (WPID) feature flag
// Controlled via REACT_APP_NONVARIANT_ENABLED build arg in kitt.yml.
// Defaults: enabled for local/stage, disabled for prod until fully released.
const _nonVariantEnvOverride = process.env.REACT_APP_NONVARIANT_ENABLED;
export const NONVARIANT_ENABLED = _nonVariantEnvOverride !== undefined
  ? _nonVariantEnvOverride === 'true'
  : getCurrentEnvironment() !== 'prod';